"use client";

import * as React from "react";
import { Smile, Meh, Frown, HelpCircle } from "lucide-react";
import { cn } from "@/lib/utils";

type IconProps = React.SVGProps<SVGSVGElement> & { className?: string };

export function SmileIcon({ className, ...props }: IconProps) {
  return <Smile className={cn("h-20 w-20 text-green-500 text-foreground/70", className)} {...props} />;
}

export function MehIcon({ className, ...props }: IconProps) {
  return <Meh className={cn("h-20 w-20 text-foreground/70", className)} {...props} />;
}

export function FrownIcon({ className, ...props }: IconProps) {
  return <Frown className={cn("h-20 w-20 text-foreground/70", className)} {...props} />;
}

export function HelpIcon({ className, ...props }: IconProps) {
  return <HelpCircle className={cn("h-20 w-20 text-foreground/70", className)} {...props} />;
}

export default {
  SmileIcon,
  MehIcon,
  FrownIcon,
  HelpIcon,
};
